import MuiFormControl, { FormControlProps as MuiFormControlProps } from '@mui/material/FormControl';

export type FormControlProps = MuiFormControlProps;

export const FormControl = (props: FormControlProps) => {
  return <MuiFormControl {...props} />;
};
